import React from 'react';
import Select from '../../audi-ui-components/Select';
import TextField from '../../audi-ui-components/TextField';

const ExtraFields = (props) => {
    return (
        <div className="mb-4">
            <p>Please complete these fields</p>
            <div className="row">
                <div className="col-12 col-tiny-6">
                    <TextField name="tradeKms"
                        value={props.values["tradeKms"]}
                        label="KMs"
                        onChange={(v) => {
                            let num = parseInt(v.replace(/[^0-9]/gi, ''));
                            let r = isNaN(num) ? "" : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            props.setFieldValue("tradeKms", r);
                        }}
                        onBlur={() => { props.setFieldTouched("tradeKms"); }}
                        isInvalid={props.errors["tradeKms"] && props.touched["tradeKms"]}
                        invalidMessage={props.errors["tradeKms"]}
                    />
                </div>
                <div className="col-12 col-tiny-6">
                    <Select name="tradeHasFinance"
                        value={props.values["tradeHasFinance"]}
                        label="Currently financed"
                        options={[{ label: "No", value: "no" }, { label: "Yes", value: "yes" }]}
                        onChange={(v) => {
                            props.setFieldValue("tradeHasFinance", v);
                        }}
                        onBlur={() => { props.setFieldTouched("tradeHasFinance"); }}
                        isInvalid={props.errors["tradeHasFinance"] && props.touched["tradeHasFinance"]}
                        invalidMessage={props.errors["tradeHasFinance"]}
                    />
                </div>
            </div>
        </div>
    );
}

export default ExtraFields;
